import { action, computed, observable, reaction, makeObservable } from 'mobx';
import Ambiente from '../utils/Ambiente';

type carregamento = 'query' | 'determinate' | 'indeterminate';

/**
 * Classe utilizada para guardar e manipular o estado da aplicação.
 * Deve-se criar uma para cada contexto ou entidade.
 */
//class AppStoreClass extends Store {
class AppStoreClass {
    constructor() {
        makeObservable<AppStoreClass, "carregando">(this, {
            carregando: observable,
            isCarregandoTodosProcessos: observable,
            isCarregandoInformacoesProcessos: observable,
            carregarApp: observable,
            quantidadeRequisicoes: observable,
            larguraJanela: observable,
            instalacaoShodoValida: observable,
            iniciarCarregamento: action,
            pararCarregamento: action,
            isCarregando: computed,
            valorCarregamento: computed,
            abrirApp: action,
            fecharApp: action,
            requisicoesPendentes: computed,
            zerarRequisicoes: action,
            incrementarRequisicoes: action,
            decrementarRequisicoes: action
        });

        this.reactionQuantidadeRequisicoes = reaction(() => this.quantidadeRequisicoes, () => {
            if (this.quantidadeRequisicoes === 0) {
                Ambiente.zerarRequisicoes();
                this.pararCarregamento();
            } else if (!this.carregando) {
                this.iniciarCarregamento();
            }
        });

        if (!(AppStoreClass as any).instance) {
            // this.inicializar();
            (AppStoreClass as any).instance = this;
        }
        return (AppStoreClass as any).instance;
    }

    private carregando: undefined | carregamento = undefined;
    isCarregandoTodosProcessos: boolean = true;
    isCarregandoInformacoesProcessos: boolean = false;

    // Contador utilizado para fornecer valores únicos para o atributo 'key', obrigatório nos arrays de componentes
    // Não deve ser observable
    uniqueKey = {
        value: 0,
        writable: true
    }
    // @see App.reactionCarregarApp
    carregarApp = false;
    // Contador de requisições ao backend utilizado na barra de progresso
    quantidadeRequisicoes = 0;
    private timeoutWatchdogRequisicoes: ReturnType<typeof setTimeout> | null = null;
    private readonly timeoutWatchdogMs = 35000;
    larguraJanela = window.innerWidth;

    instalacaoShodoValida = false;

    async inicializar() {
        // let instalacaoShodo = await this.assinaturaService.validarInstalacaoShodo();
        // runInAction(() => this.instalacaoShodoValida = instalacaoShodo);
        this.abrirApp();

    }

    public iniciarCarregamento(tipo?: carregamento) {
        this.carregando = tipo || `query`;
    }

    public pararCarregamento() {
        this.carregando = undefined;
    }

    public get isCarregando(): boolean {
        return this.carregando !== undefined;
    }

    public get valorCarregamento(): carregamento {
        return this.carregando || `query`;
    }

    abrirApp = () => {
        this.carregarApp = true;
    };

    fecharApp = () => {
        this.carregarApp = false;
    };

    reactionQuantidadeRequisicoes!: ReturnType<typeof reaction>;

    get requisicoesPendentes() {
        return this.quantidadeRequisicoes > 0;
    }

    zerarRequisicoes() {
        this.quantidadeRequisicoes = 0;
        this.limparWatchdogRequisicoes();
    }

    incrementarRequisicoes() {
        this.quantidadeRequisicoes++;
        this.reagendarWatchdogRequisicoes();
    }

    decrementarRequisicoes() {
        if (this.quantidadeRequisicoes > 0) {
            this.quantidadeRequisicoes--;
        }
        if (this.quantidadeRequisicoes === 0) {
            this.limparWatchdogRequisicoes();
        }
    }

    private reagendarWatchdogRequisicoes() {
        this.limparWatchdogRequisicoes();
        this.timeoutWatchdogRequisicoes = setTimeout(() => {
            if (this.quantidadeRequisicoes > 0) {
                console.warn('Watchdog de requisicoes acionado: zerando contador para evitar loading infinito.');
                this.zerarRequisicoes();
            }
        }, this.timeoutWatchdogMs);
    }

    private limparWatchdogRequisicoes() {
        if (this.timeoutWatchdogRequisicoes) {
            clearTimeout(this.timeoutWatchdogRequisicoes);
            this.timeoutWatchdogRequisicoes = null;
        }
    }

    incrementaKey() {
        return this.uniqueKey.value++;
    }
}

export const AppStore = new AppStoreClass();
